/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
module.exports = {
  "sitecoreApiKey": "no-api-key-set",
  "sitecoreApiHost": "",
  "jssAppName": "dpx",
  "defaultLanguage": "en",
  "graphQLEndpointPath": "/sitecore/api/graph/edge",
  "graphQLEndpoint": "/sitecore/api/graph/edge"
};